import { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import ApiService from "../../../../services/api";
import "../css/body_compositions.css";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../../services/auth";

const BodyCompositions = () => {
  const { isEnglish } = useContext(AuthContext);
  const [category, setCategory] = useState([]);
  const [compositions, setCompositions] = useState([]);
  const [Loading, setLoading] = useState(true);
  let change_color = 0;
  const fetchCategoryCompositions = async () => {
    const compositionsCategory = await ApiService.getCategories();
    const Compositions = await ApiService.getMusic();
    setCategory(
      compositionsCategory.filter((select) => select.type === "music")
    );
    setCompositions(Compositions);
    setLoading(false);
  };

  useEffect(() => {
    fetchCategoryCompositions();
  }, []);

  if (Loading) {
    return;
  }

  return (
    <Container fluid className="padding_custom text-center">
      <h2 className="text-center section-title mt-5">
        {isEnglish ? "COMPOSITIONS" : "COMPOSIZIONI"}
      </h2>
      <div className="border-custom mt-3"></div>
      <Row className="w-100 p-0 mt-5">
        {category.map((category) => {
          if (change_color === 0) {
            change_color++;
          } else {
            change_color = 0;
          }
          return (
            <div key={category.id} className="p-0 m-0">
              {compositions.filter(
                (data) => data.category.name === category.name
              ).length > 0 && (
                <Col
                  className={
                    "col-12 p-0 m-0 py-5 container-color-change-composition" +
                    change_color
                  }
                >
                  <Container className="p-0">
                    <h4 className="section-subtitle">
                      {isEnglish ? category.name_eng : category.name}
                    </h4>
                    <Row className="w-100 d-flex align-content-center justify-content-center m-0 py-5 p-0">
                      {compositions
                        .filter(
                          (filter) => filter.category.name === category.name
                        )
                        .slice(0, 4)
                        .map(({ id, img, title, link, slug }) => {
                          return (
                            <Col
                              key={id}
                              className="text-center d-flex align-content-center justify-content-center my-3"
                            >
                              {link && (
                                <a href={link} target="_blank" rel="noreferrer">
                                  <Card className="card-container-compositions">
                                    <Card.Img
                                      variant="top"
                                      src={img}
                                      className="img-compositions"
                                    />
                                  </Card>
                                </a>
                              )}
                              {!link && (
                                <Link
                                  to={category.name.toLowerCase() + "/" + slug}
                                  className=" text-decoration-none"
                                >
                                  <Card className="card-container-compositions card-container-text w-100 h-100">
                                    <Card.Img
                                      variant="top"
                                      src={img}
                                      className="card-container-img-truck"
                                    />
                                    <Card.Body className="">
                                      <Card.Title className="text_compositions">
                                        {title}
                                      </Card.Title>
                                    </Card.Body>
                                  </Card>
                                </Link>
                              )}
                            </Col>
                          );
                        })}
                      <Col className="col-12 d-flex align-content-center justify-content-center mt-5">
                        <Link to={category.name.toLowerCase()}>
                          <Button
                            variant=""
                            className="button-dark px-5"
                          >
                            <p className="text_compositions mb-0">
                              {isEnglish ? "Explore " : "Esplora "}
                            </p>
                          </Button>
                        </Link>
                      </Col>
                    </Row>
                  </Container>
                </Col>
              )}
            </div>
          );
        })}
      </Row>
    </Container>
  );
};
export default BodyCompositions;
